var React = require('react');

function XCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":1}),React.createElement("polygon",{"points":"24.42 10.42 23.58 9.58 17 16.15 10.42 9.58 9.58 10.42 16.15 17 9.58 23.58 10.42 24.42 17 17.85 23.58 24.42 24.42 23.58 17.85 17 24.42 10.42","key":2})]);
}

XCircle.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = XCircle;

XCircle.default = XCircle;
